<div class="filter-container">
  <div class="row">
    <div class="filter-window col-12">
      <div class="row">
        <div class="title-header col-12">
          <i
            class="fa fa-filter"
            aria-hidden="true"
          ></i>
          <span class="title">{{ 'FLOWS.FILTER.TITLE' | translate }}</span>
          <span class="subtitle">{{ 'FLOWS.FILTER.SUBTITLE' | translate }}</span>
        </div>
      </div>

      <div class="row">
        <div class="form-container col-12 row">
          <form
            [formGroup]="filterForm"
            class="row col-12"
          >
            <div class="col-12 col-md-6">
              <div
                class="form-group cell row col-12"
                *ngIf="customers"
              >
                <eps-select
                  [options]="customers"
                  label="ORDERS.FILTER.LABELS.CUSTOMERS"
                  formControlName="customers"
                  autoSelect
                  multiple
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <div class="form-group cell row col-12">
                <eps-select
                  [options]="filterValues.orderTypes"
                  label="FLOWS.FILTER.LABELS.FLOW_TYPE"
                  formControlName="flowTypes"
                  autoSelect
                  multiple
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <div class="form-group cell row col-12">
                <eps-select
                  [options]="filterValues.froms"
                  label="ORDERS.FILTER.LABELS.FROM"
                  formControlName="froms"
                  autoSelect
                  multiple
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <div class="form-group cell row col-12">
                <eps-select
                  [options]="filterValues.tos"
                  label="ORDERS.FILTER.LABELS.TO"
                  formControlName="tos"
                  autoSelect
                  multiple
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <div
                class="form-group cell row col-12"
                *ngIf="!customers"
              >
                <eps-select
                  [options]="shipTos"
                  label="ORDERS.FILTER.LABELS.SHIPTO"
                  formControlName="shipTos"
                  autoSelect
                  multiple
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <div class="form-group cell row col-12">
                <eps-text-input
                  label="ORDERS.FILTER.LABELS.ETM_DOCUMENT_NUMBER"
                  formControlName="etmDocumentNumber"
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-text-input>
              </div>
              <div class="form-group cell row col-12">
                <eps-select
                  [options]="definitions.flow.status"
                  label="FLOWS.FILTER.LABELS.STATUS"
                  formControlName="flowStatuses"
                  autoSelect
                  multiple
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <ng-container *ngIf="showAdvanced">
                <ng-container *ngIf="showDatesIn2rows$ | async; else showHandshakeDatesIn1row">
                  <div class="cell col-12 form-group row">
                    <eps-date-input
                      formControlName="handshakeDateFrom"
                      label="FLOWS.FILTER.LABELS.HANDSHAKE_DATE_FROM"
                      [showErrors]="false"
                      hideOptionalMarker
                    ></eps-date-input>
                  </div>
                  <div class="cell col-12 form-group row">
                    <eps-date-input
                      formControlName="handshakeDateTo"
                      label="FLOWS.FILTER.LABELS.HANDSHAKE_DATE_TO"
                      [showErrors]="false"
                      hideOptionalMarker
                    ></eps-date-input>
                  </div>
                </ng-container>
                <ng-template #showHandshakeDatesIn1row>
                  <div class="cell col-12 form-group row">
                    <eps-label-body label="FLOWS.FILTER.LABELS.HANDSHAKE_DATE">
                      <div class="eps-body">
                        <eps-date-input
                          formControlName="handshakeDateFrom"
                          labelPosition="none"
                          [showErrors]="false"
                          hideOptionalMarker
                        ></eps-date-input>
                        <eps-date-input
                          formControlName="handshakeDateTo"
                          labelPosition="none"
                          [showErrors]="false"
                          hideOptionalMarker
                        ></eps-date-input>
                      </div>
                    </eps-label-body>
                  </div>
                </ng-template>
                <ng-container *ngIf="showDatesIn2rows$ | async; else showTransferDatesIn1row">
                  <div class="cell col-12 form-group row">
                    <eps-date-input
                      formControlName="transferDateFrom"
                      label="FLOWS.FILTER.LABELS.TRANSFER_DATE_FROM"
                      [showErrors]="false"
                      hideOptionalMarker
                    ></eps-date-input>
                  </div>
                  <div class="cell col-12 form-group row">
                    <eps-date-input
                      formControlName="transferDateTo"
                      label="FLOWS.FILTER.LABELS.TRANSFER_DATE_TO"
                      [showErrors]="false"
                      hideOptionalMarker
                    ></eps-date-input>
                  </div>
                </ng-container>
                <ng-template #showTransferDatesIn1row>
                  <div class="cell col-12 form-group row">
                    <eps-label-body label="FLOWS.FILTER.LABELS.TRANSFER_DATE">
                      <div class="eps-body">
                        <eps-date-input
                          formControlName="transferDateFrom"
                          labelPosition="none"
                          [showErrors]="false"
                          hideOptionalMarker
                        ></eps-date-input>
                        <eps-date-input
                          formControlName="transferDateTo"
                          labelPosition="none"
                          [showErrors]="false"
                          hideOptionalMarker
                        ></eps-date-input>
                      </div>
                    </eps-label-body>
                  </div>
                </ng-template>
              </ng-container>
            </div>
            <div class="col-12 col-md-6">
              <ng-container *ngIf="showDatesIn2rows$ | async; else showOrderDatesIn1row">
                <div class="cell col-12 form-group row">
                  <eps-date-input
                    formControlName="florderDateFrom"
                    label="FLOWS.FILTER.LABELS.FLOW_DATE_FROM"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-date-input>
                </div>
                <div class="cell col-12 form-group row">
                  <eps-date-input
                    formControlName="florderDateTo"
                    label="FLOWS.FILTER.LABELS.FLOW_DATE_TO"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-date-input>
                </div>
              </ng-container>
              <ng-template #showOrderDatesIn1row>
                <div class="cell col-12 form-group row">
                  <eps-label-body label="FLOWS.FILTER.LABELS.FLOW_DATE">
                    <div class="eps-body">
                      <eps-date-input
                        formControlName="florderDateFrom"
                        labelPosition="none"
                        [showErrors]="false"
                        hideOptionalMarker
                      ></eps-date-input>
                      <eps-date-input
                        formControlName="florderDateTo"
                        labelPosition="none"
                        [showErrors]="false"
                        hideOptionalMarker
                      ></eps-date-input>
                    </div>
                  </eps-label-body>
                </div>
              </ng-template>
              <ng-container *ngIf="showDatesIn2rows$ | async; else showDefinitiveDatesIn1row">
                <div class="cell col-12 form-group row">
                  <eps-date-input
                    formControlName="florderDefinitiveDateFrom"
                    label="ORDERS.FILTER.LABELS.DEFINITIVE_DATE_FROM"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-date-input>
                </div>
                <div class="cell col-12 form-group row">
                  <eps-date-input
                    formControlName="florderDefinitiveDateTo"
                    label="ORDERS.FILTER.LABELS.DEFINITIVE_DATE_TO"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-date-input>
                </div>
              </ng-container>
              <ng-template #showDefinitiveDatesIn1row>
                <div class="form-group cell row col-12">
                  <eps-label-body label="ORDERS.FILTER.LABELS.DEFINITIVE_DATE">
                    <div class="eps-body">
                      <eps-date-input
                        formControlName="florderDefinitiveDateFrom"
                        labelPosition="none"
                        [showErrors]="false"
                        hideOptionalMarker
                      ></eps-date-input>
                      <eps-date-input
                        formControlName="florderDefinitiveDateTo"
                        labelPosition="none"
                        [showErrors]="false"
                        hideOptionalMarker
                      ></eps-date-input>
                    </div>
                  </eps-label-body>
                </div>
              </ng-template>
              <div class="form-group cell row col-12">
                <eps-text-input
                  label="ORDERS.FILTER.LABELS.RECEIVER_REFERENCE_NUMBER"
                  formControlName="customerReferenceNumber"
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-text-input>
              </div>
              <div class="cell col-12 form-group row">
                <eps-text-input
                  label="ORDERS.FILTER.LABELS.SENDER_REFERENCE"
                  formControlName="senderReferenceNumber"
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-text-input>
              </div>
              <div class="cell col-12 form-group row">
                <eps-text-input
                  label="ORDERS.FILTER.LABELS.SALES_ORDER_NUMBER"
                  formControlName="salesOrderNumber"
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-text-input>
              </div>
              <div class="form-group cell row col-12">
                <eps-select
                  [options]="filterValues.wholesalers"
                  label="FLOWS.DELIVERY.LABELS.WHOLESALER"
                  formControlName="wholesalers"
                  multiple
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <div *ngIf="showAdvanced">
                <div class="form-group cell row col-12">
                  <eps-label-body label="FLOWS.FILTER.LABELS.CLEARING">
                    <div class="checkboxes">
                      <eps-checkbox
                        [showErrors]="false"
                        labelPosition="none"
                        checkboxLabel="SHARED.BUTTONS.YES"
                        formControlName="clearingYes"
                        hideOptionalMarker
                      ></eps-checkbox
                      >&nbsp;&nbsp;&nbsp;
                      <eps-checkbox
                        [showErrors]="false"
                        labelPosition="none"
                        checkboxLabel="SHARED.BUTTONS.NO"
                        formControlName="clearingNo"
                        hideOptionalMarker
                      ></eps-checkbox>
                    </div>
                  </eps-label-body>
                </div>
                <div class="form-group cell row col-12">
                  <eps-select
                    [options]="filterValues.packings"
                    label="FLOWS.FILTER.LABELS.PACKING_ID"
                    formControlName="packingIds"
                    autoSelect
                    multiple
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-select>
                </div>
              </div>
            </div>

            <div class="row col-12 filter-buttons">
              <eps-button
                [disabled]="filterForm.disabled"
                (buttonClick)="showAdvanced = true"
                type="link"
                *ngIf="!showAdvanced"
                label="ORDERS.FILTER.BUTTONS.MORE_SEARCH_OPTIONS"
              ></eps-button>
              <eps-button
                [disabled]="filterForm.disabled"
                (buttonClick)="showAdvanced = false"
                type="link"
                *ngIf="showAdvanced"
                label="ORDERS.FILTER.BUTTONS.LESS_SEARCH_OPTIONS"
              ></eps-button>
              <eps-button
                [disabled]="filterForm.disabled"
                (buttonClick)="resetFilter()"
                minWidth="160px"
                buttonIcon="eraser"
                label="SHARED.BUTTONS.CLEAR_FILTERS"
              ></eps-button>
              <eps-button
                [disabled]="filterForm.invalid || filterForm.disabled"
                [busy]="isLoading"
                (buttonClick)="filterClicked()"
                type="primary"
                buttonIcon="filter"
                minWidth="160px"
                submit
                label="FLOWS.FILTER.BUTTONS.FILTER_TEXT"
              ></eps-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
